export const isWhiteSpace = (str) => /^\s*$/.test(str);
